import { render } from "./TabInvoiceHistory.vue?vue&type=template&id=27548065"
import script from "./TabInvoiceHistory.vue?vue&type=script&lang=js"
export * from "./TabInvoiceHistory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__